import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询区域汇总信息列表
export const get_operatingLog_list = (params) => {
  params = {
    row: {
      startDate: params.startDate,
      endDate: params.endDate,
      groupId: params.groupId,
    }
  }
  return post_request("/web/projectOperatingLog/areaSummary2", params)
}

//获取区域列表
export const get_projectOperatingLog_list = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/projectOperatingLog/cloudPlatformAreaSummary", params)
}
//获取车辆类型
export const get_projectOperatingLog_carType = (params) => {
  params = {
    row: {
      groupId: params.groupId,
      startDate: params.startDate,
      endDate: params.endDate,
    }
  }
  return post_request("/web/projectOperatingLog/getAllType", params)
}
//根据车辆类型分类统计列表
export const get_operatingLog_one_list = (params, carType) => {
  params = {
    row: {
      startDate: params.startDate,
      endDate: params.endDate,
      groupId: params.groupId || '0',
      carType: carType
    }
  }
  return post_request("/web/projectOperatingLog/carTypeSummary", params)
}
// //导出区域汇总信息列表
// export const get_exportArea_list = (params) => {
//   params = {
//     row: {
//       startDate: params.startDate,
//       endDate: params.endDate,
//       groupId: params.groupId,
//     }
//   }
//   return get_request_export("/web/projectOperatingLog/exportArea", params)
// }
// //导出车辆类型信息列表
// export const get_carTypeExport_list = (params,carType) => {
//   params = {
//     row: {
//       startDate: params.startDate,
//       endDate: params.endDate,
//       groupId: params.groupId,
//       carType:carType
//     }
//   }
//   return get_request_export("/web/projectOperatingLog/carTypeExport", params)
// }
//导出所有信息
export const get_carTypeExport_all_list = (params) => {
  params = {
    row: {
      startDate: params.startDate,
      endDate: params.endDate,
      groupId: params.groupId,
    }
  }
  return get_request_export("/web/projectOperatingLog/export_all", params)
}



// WEBPACK FOOTER //
// ./src/api/projectLog/operationLog.js